import { Component, OnInit } from "@angular/core";
import { SearchNotificationService } from "../search-notification.service";
import { Router } from "@angular/router";

@Component({
  selector: "app-user-vacant-vehicle-search-list",
  templateUrl: "./user-vacant-vehicle-search-list.component.html",
  styleUrls: ["./user-vacant-vehicle-search-list.component.sass"],
})
export class UserVacantVehicleSearchListComponent implements OnInit {
  searchHistory: any[] = [];

  loading = false;

  page = 1;
  limit = 10;

  total = 0;
  totalPages = 0;

  constructor(
    private searchHistoryService: SearchNotificationService,
    private router: Router,
  ) {}

  ngOnInit(): void {
    this.getSearchHistory();
  }

  getSearchHistory(): void {
    this.loading = true;

    const data = {
      page: this.page,
      limit: this.limit,
    };

    this.searchHistoryService.getUserSearchHistory(data).subscribe(
      (res: any) => {
        this.loading = false;

        if (res && res.success) {
          this.searchHistory = res.data || [];

          if (res.pagination) {
            this.page = res.pagination.page;
            this.limit = res.pagination.limit;
            this.total = res.pagination.total;
            this.totalPages = res.pagination.totalPages;
          }
        } else {
          this.searchHistory = [];
          this.total = 0;
          this.totalPages = 0;
        }
      },
      (error) => {
        this.loading = false;
        this.searchHistory = [];

        console.error("Error fetching user search history:", error);
      },
    );
  }

  changePage(page: number): void {
    if (page < 1 || page > this.totalPages) {
      return;
    }

    if (page === this.page) {
      return;
    }

    this.page = page;

    this.getSearchHistory();
  }

  nextPage(): void {
    if (this.page < this.totalPages) {
      this.page++;
      this.getSearchHistory();
    }
  }

  previousPage(): void {
    if (this.page > 1) {
      this.page--;
      this.getSearchHistory();
    }
  }

  getPages(): number[] {
    const pages: number[] = [];

    for (let i = 1; i <= this.totalPages; i++) {
      pages.push(i);
    }

    return pages;
  }

  trackById(index: number, item: any): any {
    return item._id;
  }

  viewDetails(id: any): void {
    if (!id) {
      return;
    }

    this.router.navigate(["dashboard/user-view-vacant-vehicle-search"], {
      queryParams: { id: id },
    });
  }
}
